export default "__VITE_ASSET__F868$0vo__"